// extracted by mini-css-extract-plugin
export var blue = "_21-h";
export var brand = "_21-d";
export var darkGrey = "_21-g";
export var disabled = "_21-6";
export var disabledSubtle = "_21-7";
export var error = "_21-8";
export var green = "_21-i";
export var grey = "_21-f";
export var icon = "_21-0";
export var inherit = "_21-c";
export var lightGrey = "_21-e";
export var orange = "_21-k";
export var pink = "_21-m";
export var primary = "_21-1";
export var purple = "_21-n";
export var quaternary = "_21-4";
export var quinary = "_21-5";
export var red = "_21-l";
export var secondary = "_21-2";
export var success = "_21-b";
export var tertiary = "_21-3";
export var warning = "_21-9";
export var warningSecondary = "_21-a";
export var white = "_21-o";
export var yellow = "_21-j";